export const VOICE_GENDER_STORAGE_KEY = 'voiceGenderPreference';
export const VOICE_PROFILE_STORAGE_KEY = 'voiceProfilePreference';

export const VOICE_GENDERS = [
  { value: 'female', label: 'Female' },
  { value: 'male', label: 'Male' },
];

export const VOICE_PROFILES = [
  {
    value: 'us',
    label: 'American English',
    speechLang: 'en-US',
    ttsLang: 'en-US',
    ttsFemaleVoice: 'en-US-Wavenet-F',
    ttsMaleVoice: 'en-US-Wavenet-D',
  },
  {
    value: 'uk',
    label: 'British English',
    speechLang: 'en-GB',
    ttsLang: 'en-GB',
    ttsFemaleVoice: 'en-GB-Wavenet-A',
    ttsMaleVoice: 'en-GB-Wavenet-B',
  },
  {
    value: 'in',
    label: 'Indian English',
    speechLang: 'en-IN',
    ttsLang: 'en-IN',
    ttsFemaleVoice: 'en-IN-Wavenet-A',
    ttsMaleVoice: 'en-IN-Wavenet-B',
  },
  {
    value: 'au',
    label: 'Australian English',
    speechLang: 'en-AU',
    ttsLang: 'en-AU',
    ttsFemaleVoice: 'en-AU-Wavenet-A',
    ttsMaleVoice: 'en-AU-Wavenet-B',
  },
];

export const DEFAULT_VOICE_GENDER = 'female';
export const DEFAULT_VOICE_PROFILE = 'us';

function normalizeGender(gender) {
  return gender === 'male' ? 'male' : DEFAULT_VOICE_GENDER;
}

export function getVoiceProfile(profileValue) {
  return (
    VOICE_PROFILES.find((profile) => profile.value === profileValue) ||
    VOICE_PROFILES.find((profile) => profile.value === DEFAULT_VOICE_PROFILE) ||
    VOICE_PROFILES[0]
  );
}

export function getStoredVoicePreferences() {
  if (typeof window === 'undefined') {
    return {
      gender: DEFAULT_VOICE_GENDER,
      profile: getVoiceProfile(DEFAULT_VOICE_PROFILE),
    };
  }

  const storedGender = window.localStorage.getItem(VOICE_GENDER_STORAGE_KEY) || DEFAULT_VOICE_GENDER;
  const storedProfileValue = window.localStorage.getItem(VOICE_PROFILE_STORAGE_KEY) || DEFAULT_VOICE_PROFILE;
  return {
    gender: normalizeGender(storedGender),
    profile: getVoiceProfile(storedProfileValue),
  };
}

export function saveVoicePreferences({ gender, profileValue }) {
  if (typeof window === 'undefined') {
    return;
  }

  const normalizedGender = normalizeGender(gender);
  const profile = getVoiceProfile(profileValue);

  window.localStorage.setItem(VOICE_GENDER_STORAGE_KEY, normalizedGender);
  window.localStorage.setItem(VOICE_PROFILE_STORAGE_KEY, profile.value);
}

export function getTalkingHeadVoiceConfig() {
  const { gender, profile } = getStoredVoicePreferences();
  return {
    speechLang: profile.speechLang,
    ttsLang: profile.ttsLang,
    ttsVoice: gender === 'male' ? profile.ttsMaleVoice : profile.ttsFemaleVoice,
    gender,
    profile,
  };
}
